






















































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import { CommonService } from "@/zh-website/src/views/Enterprise/service/CommonService";
@Component({
  components: {
    Banner,
    SideBar
  }
})
export default class CommonCase extends Vue {
  //
  navigationName = "" as any;
  classifyName = "" as any;
  classifyLink = "" as any;
  navigationLink = "" as any;
  bannerData = {
    font4: "他山之石 可以攻玉",
    font5: "使能千行百业数字化人才转型",
    font3: "",
    button: "",
    style: {
      "background-image":
        'url("' + require("../../../../assets/case_banner.jpg") + '")',
      height: "320px"
    }
  };
  title = "数字金融";
  isFixed = false;
  activeIndex = 0;
  tabs = [];
  CaseList = [];

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getAllNavigation();
    this.getSuccessCasesList();
  }
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  //面包屑导航
  getAllNavigation() {
    CommonService.getAllClassification({}).then((res: any) => {

      res.data.forEach((nav: any, index) => {
        //set the jump link
        let link: string = "";
        if (index == 0) link = "industry";
        else if (index == 1) link = "product";
        else if (index == 2) link = "digital";
        nav.child.forEach((classify: any) => {
          if (classify.child) {
            classify.child.forEach((solution: any) => {
              if (solution.id == this.$route.params.id) {
                this.classifyName = classify.name;
                this.navigationName = nav.name;
                this.navigationLink = `/enterprise/${link}/page`;
                if (link == "industry")
                  this.navigationLink = `/enterprise/page`;
                this.classifyLink = `/enterprise/${link}/classify/${classify.id}`;
              }
            });
          }
        });
      });
    });
  }

  getSuccessCasesList() {
    CommonService.getSuccessCasesList({
      solutionId: this.$route.params.id
    }).then((res: any) => {
      this.tabs = res.data.list;
      this.CaseList = res.data.list;
    });
  }
  handleScroll() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    const offsetTop = (document.getElementById("bar") as any).offsetTop;

    if (scrollTop > 590) {
      this.isFixed = true;
    } else {
      this.isFixed = false;
    }
  }
  changeMask(e) {
    this.activeIndex = e;
    if (this.isFixed) {
      window.scrollTo({
        top: 590,
        behavior: "smooth"
      });
    }
  }
}
